const SESSION_KEY_PREFIX = 'chat_widget_session_'

/**
 * Recupera el sessionId del sessionStorage para un agentId dado.
 * Devuelve null si no existe (sesión nueva).
 */
export function getOrCreateSession(agentId: string): string | null {
  try {
    return sessionStorage.getItem(SESSION_KEY_PREFIX + agentId)
  } catch {
    return null
  }
}

/**
 * Guarda el sessionId en sessionStorage para un agentId dado.
 */
export function saveSession(agentId: string, sessionId: string): void {
  try {
    sessionStorage.setItem(SESSION_KEY_PREFIX + agentId, sessionId)
  } catch {
    // sessionStorage no disponible (incógnito con restricciones, etc.)
  }
}

/**
 * Elimina el sessionId del sessionStorage (cerrar sesión del visitante).
 */
export function clearSession(agentId: string): void {
  try {
    sessionStorage.removeItem(SESSION_KEY_PREFIX + agentId)
  } catch {
    // noop
  }
}
